'use client';

import { ChevronDown } from '@v2/ui/Icon/Arrow';
import { Popover, PopoverTrigger } from '@v2/ui/Popover';
import dynamic from 'next/dynamic';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

const SportsDropdownContent = dynamic(
  () =>
    import('./SportsDropdownContent').then(
      (module) => module.SportsDropdownContent
    ),
  { ssr: false }
);

interface Props {
  buttonStyle: string;
  variant: 'black' | 'white';
}

export const SportsDropdown = ({ buttonStyle, variant }: Props) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const searchParams = useSearchParams();
  const isSportsDropdownOpen = searchParams?.get('sportsDropdown');

  useEffect(() => {
    if (isSportsDropdownOpen) setIsDropdownOpen(true);
  }, [isSportsDropdownOpen]);

  return (
    <Popover open={isDropdownOpen} onOpenChange={setIsDropdownOpen}>
      <PopoverTrigger asChild>
        <button
          aria-expanded={isDropdownOpen}
          className={`flex items-center gap-2 rounded-lg border-2 p-3 ${isDropdownOpen ? buttonStyle : 'border-transparent'}`}
        >
          Sports <ChevronDown stroke={variant} size="20" />
        </button>
      </PopoverTrigger>
      {isDropdownOpen && (
        <SportsDropdownContent onClose={() => setIsDropdownOpen(false)} />
      )}
    </Popover>
  );
};
